import { pathgen } from 'object-path-generator';
import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useArchiveDraftTestIds = pathgen('useArchiveDraftTestIds');
export const useArchiveDraft = function useArchiveDraft() {
    let { onSuccess, withPageLoader, biCode } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (draftId)=>api.draft.archive(draftId),
        withPageLoader,
        biCode,
        mutationName: 'archive-draft',
        toasts: {
            successMessage: 'Draft archived successfully',
            successTestId: useArchiveDraftTestIds.SuccessToast(),
            errorMessage: 'Failed to archive draft',
            errorTestId: useArchiveDraftTestIds.ErrorToast()
        },
        onSuccess: ()=>{
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        archive: mutate,
        isLoading
    };
};
